<template>
  <form class="form-inline">
    <div class="alert alert-danger" v-if="errors.length > 0">
      <ul>
        <li v-for="error in errors">{{error}}</li>
      </ul>
    </div>
    <div class="input-group mr-sm-2 mb-sm-0" v-if="verifiedEmail != 1">
      <div class="input-group-addon">@</div>
      <input v-if="verifiedEmail == -1"
             class="form-control"
             v-model='email'
             type='text'
             placeholder='john.smith@gmail.com'/>
      <span v-if="verifiedEmail == 0">
            <input
              type="text"
              placeholder="Verify Code"
              v-model="verifyCode"
              class="form-control"
            >
            <button :disabled="!isValid" class='btn btn-primary' value='send'
                    v-on:click="verify()">
              <i class="fa fa-spin fa-spinner" v-if="loading"></i>
              Verify {{ email }}
            </button>
          </span>
    </div>
    <span v-if="verifiedEmail == 1">
            {{email}} (verified)
        </span>
    <button v-if="verifiedEmail == -1"
            :disabled="!isValid"
            class='btn btn-primary'
            value='send'
            v-on:click="createOrVerify()">
      <i class="fa fa-spin fa-spinner" v-if="loading"></i>
      Verify Your Email
    </button>

  </form>
</template>
<style lang="scss" scoped>

</style>
<script>
  export default {
    data() {
      return {
        email: '',
        verifiedEmail: -1,
        verifyCode: '',
        userId: 0,
        loading: false,
        errors: [],
      };
    },
    computed: {
      isValid() {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
        return !this.loading && re.test(this.email);
      },
    },
    methods: {
      createOrVerify() {
        const url = `${process.env.DOMAIN}/api/email/`;
        this.loading = true;
        this.$http.post(url, { email: this.email }).then((response) => {
          this.loading = false;
          this.userId = response.body.pk;
          if (!response.body.verified) {
            this.verifiedEmail = 0;
          } else {
            this.verifiedEmail = 1;
            this.$emit('setemail', this.email);
          }
        });
      },
      verify() {
        const url = `${process.env.DOMAIN}/api/email/${this.userId}/verify/`;
        this.loading = true;
        const data = {
          code: this.verifyCode,
          email: this.email,
        };
        this.$http.post(url, data).then(() => {
          this.verifiedEmail = 1;
          this.$emit('setemail', this.email);
        },
        () => {
          this.errors = ['Invalid code. Please check your email and try again'];
        }
      ).finally(() => { this.loading = false; });
      },
    },
  };
</script>


// WEBPACK FOOTER //
// Verify.vue?0d40c76a